const EMAIL_REGEX =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const checkValidity = e => {
  e.preventDefault()
  if (!e.target.checkValidity()) {
    // focus the first invalid input
    e.target.querySelector(':invalid')?.focus()
    return false
  }
  return true
}

const emailIsValid = email => EMAIL_REGEX.test(String(email).toLowerCase())

const customErrorOrDefault = customMessage => e => {
  const message = customMessage(e)
  if (message) return message

  return e.target.validationMessage
}

const parseNumberInput = e => (e.target.value >= e.target.min ? +e.target.value : e.target.min)

const form = { checkValidity, emailIsValid, customErrorOrDefault, parseNumberInput }

export default form
